interface ErrorResponse {
    code: number;
    message: string;
    method?: string;
}

export interface ShareTicketState {
    shareTicketData: any;
    loading: boolean;
    shareTicketErrorDara: ErrorResponse | null;
}


export enum ShareTicketActionTypes {
    FETCH_SHARETICKET_DATA = "FETCH_SHARETICKET_DATA",
    FETCH_SHARETICKET_DATA_SUCCESS = "FETCH_SHARETICKET_DATA_SUCCESS",
    FETCH_SHARETICKET_DATA_ERROR = "FETCH_SHARETICKET_DATA_ERROR",
}

export type ShareTicketAction =
    | { type: ShareTicketActionTypes.FETCH_SHARETICKET_DATA }
    | { type: ShareTicketActionTypes.FETCH_SHARETICKET_DATA_SUCCESS; payload: any }
    | { type: ShareTicketActionTypes.FETCH_SHARETICKET_DATA_ERROR; payload: any };